import { useQuery } from '@tanstack/react-query'
import useCycleApi from 'common/hooks/useCycleApi'
import { BaseResponse } from 'common/types/api'
import { selectedCycleIdState } from 'modules/pond/stores/atom'
import { useRecoilValue } from 'recoil'

import { TRANSFER_REQUEST_CONFIG } from '.'
import {
  getLatestCostPerKgKey,
  getShrimpTransferKey,
  getTransferRecentSizeKey,
} from 'common/constants/queryKeys'
import { GetPartialTransferResponse, LatestCostPerKg, TransferRecentSize } from './types'

export const useGetShrimpTransfer = () => {
  const cycleApi = useCycleApi()
  const cycleId = useRecoilValue(selectedCycleIdState)
  const initParams = {
    params: {},
    cycleId,
  }

  return useQuery({
    queryKey: getShrimpTransferKey(cycleId || ''),
    queryFn: async ({ pageParam = initParams }) => {
      const { data } = await cycleApi.request<BaseResponse<GetPartialTransferResponse>>({
        ...TRANSFER_REQUEST_CONFIG.get,
        ...pageParam,
      })
      if (data.data.partial_transfers) {
        return data.data.partial_transfers
      }
      return []
    },
    staleTime: Infinity,
    enabled: !!cycleId,
    refetchOnMount: 'always'
  })
}

export const useGetLatestCostPerKg = (enabled = true) => {
  const cycleApi = useCycleApi()
  const cycleId = useRecoilValue(selectedCycleIdState)

  return useQuery({
    queryKey: getLatestCostPerKgKey(cycleId || ''),
    queryFn: async () => {
      const { data } = await cycleApi.request<BaseResponse<LatestCostPerKg>>(
        TRANSFER_REQUEST_CONFIG.getLatestCostPerKg
      )
      return data.data
    },
    staleTime: Infinity,
    enabled: enabled && !!cycleId,
  })
}

export const useGetTransferRecentSize = (date?: string, enabled = true) => {
  const cycleApi = useCycleApi()
  const cycleId = useRecoilValue(selectedCycleIdState)

  return useQuery({
    queryKey: getTransferRecentSizeKey(cycleId || '', date),
    queryFn: async () => {
      const { data } = await cycleApi.request<BaseResponse<TransferRecentSize>>({
        ...TRANSFER_REQUEST_CONFIG.getRecentSize,
        params: { date },
        silentError: true,
      })
      return data.data
    },
    staleTime: Infinity,
    enabled: enabled && !!cycleId && !!date,
  })
}
